import { __rest } from "tslib";
import { number, func, bool, elementType, node, string } from 'prop-types';
import React, { useState, useEffect } from 'react';
import useDebounce from 'react-use/lib/useDebounce';
import { useForm } from 'react-final-form';
const NOOP = () => false;
export const DebouncedInput = (props) => {
    const { value, onChange, delay, canSubmit, minimum, component, error } = props, otherProps = __rest(props, ["value", "onChange", "delay", "canSubmit", "minimum", "component", "error"]);
    const Component = component;
    const [inputValue, setInputValue] = useState(value || '');
    const [debouncedValue, setDebouncedValue] = useState(value || '');
    const form = useForm();
    const handleInput = ({ target }) => {
        setInputValue(target.value);
    };
    useDebounce(() => {
        setDebouncedValue(inputValue);
    }, delay, [inputValue]);
    useEffect(() => {
        onChange(debouncedValue);
        const hasMinLength = debouncedValue.length >= minimum || debouncedValue.length === 0;
        if (form && canSubmit && hasMinLength) {
            form.submit();
        }
    }, [canSubmit, debouncedValue, form, minimum, onChange, error]);
    return React.createElement(Component, Object.assign({}, otherProps, { onChange: handleInput }));
};
DebouncedInput.defaultProps = {
    delay: 200,
    canSubmit: true,
    minimum: 2,
    onChange: NOOP,
};
DebouncedInput.propTypes = {
    /** the value of the input **/
    value: string,
    /** callback function used when the control value changes **/
    onChange: func,
    /** time in millis before the input is evaluated **/
    delay: number,
    /** if true, this field can autosubmit its parent Form **/
    canSubmit: bool,
    /** minimum number of characters entered to be valid for submission **/
    minimum: number,
    /** the component to render **/
    component: elementType.isRequired,
    /** a field validation error that can trigger a rerender **/
    error: node,
};
//# sourceMappingURL=DebouncedInput.js.map